import type {Method} from '@wix/document-services-types'

export interface HttpServer {
    fetch<T = any, R = any>(url: string, method: Method, data?: R): Promise<T>
}
